
import { pathOr } from "ramda";
import { mapState } from "vuex";

export default {
  props: { descriptionHtml: { type: String, default: "" } },

  data: () => ({ isExpanded: false }),

  computed: {
    ...mapState(["siteConfig"]),
    charLimit() {
      return pathOr(300, ["pdp", "descriptionCharLimit"], this.siteConfig);
    },
    showReadMore() {
      return this.descriptionHtml.length > this.charLimit;
    },
  },
};
